import { render, staticRenderFns } from "./OtherTrapezoidsB.vue?vue&type=template&id=4bd76302&scoped=true"
import script from "./OtherTrapezoidsB.vue?vue&type=script&lang=js"
export * from "./OtherTrapezoidsB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd76302",
  null
  
)

export default component.exports